import { Route } from "react-router-dom";
import UserProfileContainer from "containers/user-profile/user-profile-container";
import GuestProfileRestrictedRedirect from "components/guest-profile-restricted-redirect/guest-profile-restricted-redirect";
import AuthorizedFileContainer from "containers/file-authorized/authorized-file-view-container";
import FuelReportContainer from "containers/fuel-report-view-container/fuel-report-view-container";
import BusinessTripContainer from "containers/business-trip-view-container/business-trip-view-container";

// The cabinet's addresses, inside /app/:companyId. Every address of the form
// profile/:userId/<section> opens UserProfileContainer, which picks the section
// from the first segment; the detail pages of a fuel report and a business trip
// have their own routes. "files", "downloads" and "onboarding-documents" end in
// /* because the documents tree inside those sections has routes of its own.
export const profileRoutes = (
  <>
    <Route path="profile/:userId" element={<UserProfileContainer />} />
    <Route path="profile/:userId/info" element={<UserProfileContainer />} />
    <Route path="profile/:userId/assets" element={<UserProfileContainer />} />
    <Route path="profile/:userId/leaves" element={<UserProfileContainer />} />
    <Route
      path="profile/:userId/fuel-reports"
      element={<UserProfileContainer />}
    />
    <Route
      path="profile/:userId/business-trips"
      element={<UserProfileContainer />}
    />
    <Route path="profile/:userId/expenses" element={<UserProfileContainer />} />
    <Route
      path="profile/:userId/fuel-reports/:reportId"
      element={
        <GuestProfileRestrictedRedirect>
          <FuelReportContainer source="profile" />
        </GuestProfileRestrictedRedirect>
      }
    />
    <Route
      path="profile/:userId/business-trips/:tripId"
      element={
        <GuestProfileRestrictedRedirect>
          <BusinessTripContainer source="profile" />
        </GuestProfileRestrictedRedirect>
      }
    />
    <Route path="profile/:userId/files/*" element={<UserProfileContainer />} />
    <Route
      path="profile/:userId/onboarding-documents/*"
      element={<UserProfileContainer />}
    />
    <Route
      path="profile/:userId/medical-check"
      element={<UserProfileContainer />}
    />
    <Route
      path="profile/:userId/downloads/*"
      element={<UserProfileContainer />}
    />
    <Route
      path="profile/:userId/roles"
      element={
        <GuestProfileRestrictedRedirect>
          <UserProfileContainer />
        </GuestProfileRestrictedRedirect>
      }
    />
    <Route
      path="profile/files/:catId/:fileId"
      element={<AuthorizedFileContainer source="profile" />}
    />
  </>
);
